// import {  logDebugging } from '../../../log/logger';

import { logDebugging } from '../../../log/logger';

export default class NativePlayerController {
  constructor(videoData, handler) {
    this.videoData = videoData;
    this.handler = handler;
  }

  initialize() {
    // eslint-disable-next-line no-undef
    this.videoSlot = document.getElementById(this.videoData.idVideoElement);
    if (!this.videoSlot) {
      throw new Error('[NativePlayerController] error. No video element ');
    }
    // logDebugging('NativePlayerController.initialize()');
    if (!this.adIsStarted) {
      // si ya ha empezado controlamos con este flag que no se inicie otra vez desde otro sitio.
      this.adIsStarted = true;
      if (this.videoData.url) {
        this.videoContentUrl = this.videoSlot.currentSrc;
        this.videoSlot.src = this.videoData.url;
        this.videoSlot.load();
      } else {
        throw new Error('[NativePlayerController] error. No url File ');
      }
    } else {
      // logDebugging('metodo start llamado pero video ya iniciado');
    }
  }

  start(force) {
    // logDebugging('NativePlayerController.start()');
    if (this.videoSlot) {
      if (force) {
        this.handler.isFirstStart = false;
      }
      this.videoSlot
        .play()
        .then(() => {})
        .catch((error) => {
          logDebugging(error);
          this.handler.playError();
        });
    }
  }

  remove() {
    this.skip();
  }

  pause() {
    // logDebugging(this.videoSlot);
    if (this.videoSlot) this.videoSlot.pause();
  }

  resume() {
    // this.handler.addHandlers();
    if (this.videoSlot) {
      this.videoSlot
        .play()
        .then(() => {})
        .catch((error) => {
          logDebugging(error);
          this.handler.playError();
        });
    }
  }

  seekTo(percent) {
    if (this.videoSlot) {
      this.videoSlot.currentTime = (percent * this.getDuration()) / 100;
    }
  }

  skip() {
    this.unloadVideo();
    this.handler.skip();
  }

  replay() {
    this.unloadVideo();
    this.handler.replay();
  }

  unloadVideo() {
    if (this.videoSlot) {
      this.videoSlot.removeAttribute('src');
      this.videoSlot.load();
      delete this.videoSlot;
    }
  }

  getVolume() {
    if (this.videoSlot) {
      return this.videoSlot.volume;
    }
    return 0;
  }

  setVolume(value) {
    if (this.videoSlot) this.videoSlot.volume = value;
  }

  mute() {
    if (this.videoSlot) this.videoSlot.muted = true;
  }

  unmute() {
    if (this.videoSlot) this.videoSlot.muted = false;
  }

  getDuration() {
    try {
      return this.videoSlot.duration;
    } catch (error) {
      return null;
    }
  }

  getCurrentTime() {
    if (this.videoSlot) {
      return this.videoSlot.currentTime;
    }
    return 0;
  }

  getRemainingTime() {
    try {
      if (this.videoSlot) {
        return this.videoSlot.duration - this.videoSlot.currentTime;
      }
      return -1;
    } catch (error) {
      return -1;
    }
  }

  getClickThrough() {
    try {
      return this.vastModel.clickThrough;
    } catch (err) {
      return '';
    }
  }

  // eslint-disable-next-line class-methods-use-this
  resize() {}
}
